import { useState } from "react"
import PropTypes from "prop-types"
import { Flex, Button } from "antd"
import CustomDrawer from "ui/Drawer"
import ActionQueue from "../BookingTable/ActionQueue"
import UpcomingCard from "./UpcomingCard"
import styles from "./index.module.css"

// Mobile (xs–sm) view for Upcoming Experiences: a card per row, with the ⋯ Actions
// bottom sheet (View Details / Open Actions Queue) and the Action Queue bottom sheet.
const UpcomingMobileList = ({ items = [], onViewDetails }) => {
  const [actionsItem, setActionsItem] = useState(null)
  const [queueGroupId, setQueueGroupId] = useState(null)

  const closeActions = () => setActionsItem(null)
  const closeQueue = () => setQueueGroupId(null)

  return (
    <>
      <Flex vertical gap={10}>
        {items.map((item) => (
          <UpcomingCard key={item.uuid} item={item} onOpenActions={setActionsItem} />
        ))}
      </Flex>

      {/* Actions bottom sheet */}
      <CustomDrawer open={!!actionsItem} setOpen={(open) => !open && closeActions()} title="Actions">
        <Flex vertical gap={12} className={styles.actionsSheet}>
          <Button
            block
            shape="round"
            className={styles.actionBtn}
            onClick={() => {
              if (actionsItem) onViewDetails?.(actionsItem)
              closeActions()
            }}
          >
            View Details
          </Button>
          <Button
            block
            shape="round"
            className={styles.actionBtn}
            onClick={() => {
              if (actionsItem) setQueueGroupId(actionsItem.groupId || actionsItem.uuid)
              closeActions()
            }}
          >
            Open Actions Queue
          </Button>
        </Flex>
      </CustomDrawer>

      {/* Action Queue bottom sheet (reuses the desktop ActionQueue) */}
      <CustomDrawer open={!!queueGroupId} setOpen={(open) => !open && closeQueue()}>
        {queueGroupId && <ActionQueue groupId={queueGroupId} />}
      </CustomDrawer>
    </>
  )
}

UpcomingMobileList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onViewDetails: PropTypes.func
}

export default UpcomingMobileList
